@if (!parcel) {
    <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
}
@if (!loadingData) {
    <div class="entity-header clearfix">
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs" [currentPageTitle]="parcel.acctNum"></ws-bread-crumbs>
        @if (parcel) {
            <div class="float-end mt-1">
                <!--<li [disabled]="{ 'disabled': (!prevParcelId) || loadingData}">-->
                <button
                    class="ace-btn has-icon btn-text icon-dark fa fa-chevron-left mb-0"
                    [disabled]="!prevParcelId || loadingData"
                    title="Previous Parcel"
                    (click)="openParcel(prevParcelId)"
                >
                </button>
                <button
                    class="ace-btn has-icon btn-text icon-dark fa fa-chevron-right mb-0"
                    [disabled]="!nextParcelId || loadingData"
                    title="Next Parcel"
                    (click)="openParcel(nextParcelId)"
                >
                </button>
            </div>
        }
    </div>
}
@if (parcel) {
    <div class="parcel" [ngClass]="{ 'panel-maximized': panelMaximized }">
        <div class="row equal-panel row-eq-height">
            <div class="col-xl-5 panel-container">
                <parcel-info-panel-new
                    [parcelViewDto]="parcelViewDTO"
                    [stateAllowConsolidating]="stateAllowConsolidating"
                    (getAnnualGridCallback)="getAnnualGridAndCompTypes($event)"
                    (parcelInfoChanged)="parcelInfoChanged($event)"
                >
                </parcel-info-panel-new>
            </div>
            <div class="col-xl-7 panel-container">
                <div class="card panel-flat-color secondary-panel">
                    <div class="panel-flat-header">
                        <div class="header-icon"><i class="fa fa-bell fa-fw"></i></div>
                        <h3>Activity</h3>
                    </div>
                    <div class="panel-flat-body short">
                        <parcel-activity-summary [parcelId]="parcelId" [showComplianceInfo]="showComplianceInfo">
                        </parcel-activity-summary>
                    </div>
                </div>
            </div>
        </div>
        @if (!maximize) {
            <div class="row equal-panel row-eq-height">
                <div
                    class="panel-container"
                    [ngClass]="{
                        'current-max-panel': panelMaximized === 'annualDetails',
                        'col-xl-12': panelMaximized && panelMaximized !== 'responsibleEntityPanel',
                        'col-xl-8': !panelMaximized || panelMaximized === 'responsibleEntityPanel',
                    }"
                >
                    <annual-details
                        [hasWritePermission]="hasWritePermission"
                        [stateId]="parcel.address.stateID"
                        [assessorId]="parcel.assessorID"
                        [companyId]="companyId"
                        [topLevelCompanyId]="topLevelCompanyId"
                        [returnPreparationAllowed]="ppReturnPreparationAllowed"
                        [parcelId]="parcelId"
                        [entityTypeId]="entity.typeId"
                        [siteId]="siteId"
                        [hasCompanyCollectors]="parcel.hasCompanyCollectors"
                        [hasComplianceResponsibility]="hasComplianceResponsibility"
                        [parcelAcctNum]="parcel.acctNum"
                        [masterParcelId]="parcel.masterParcelId"
                        [parcelLinkageTypeId]="parcel.linkageTypeId"
                        [consolidatingTypeId]="parcel.consolidatingTypeId"
                        [consolidatedParcelId]="parcel.consolidatedParcelId"
                        [propertyType]="parcel.propertyType.propertyTypeID"
                        [componentTypes]="compTypes"
                        [annualYearData]="annualYearData"
                        (maximizeChanged)="maximizeChanged('annualDetails', $event)"
                    >
                    </annual-details>
                </div>
                <div
                    class="col-xl-4 panel-container"
                    [ngClass]="{
                        'current-max-panel': panelMaximized === 'propertyCharacteristics',
                        'col-xl-12': panelMaximized && panelMaximized !== 'responsibleEntityPanel',
                        'col-xl-4': !panelMaximized || panelMaximized === 'responsibleEntityPanel',
                    }"
                >
                    <entity-property-characteristics class="full-panel" [instanceId]="instanceId" [isParcel]="true">
                    </entity-property-characteristics>
                </div>
            </div>
        }
        @if (parcel.accrualsEnabled) {
            <div class="row">
                <div class="col-xl-12 panel-container">
                    <accruals-panel [parcelId]="parcelId" [hasEditPermission]="hasWritePermission"></accruals-panel>
                </div>
            </div>
        }
        <div class="row">
            <div class="col-xl-12 panel-container">
                <client-services-panel [entity]="entity" (getAnnualGridCallback)="getAnnualGridAndCompTypes($event)">
                </client-services-panel>
            </div>
        </div>
        <div class="row panel-container">
            <div class="col-xl-12">
                <asset-list-panel
                    [companyId]="topLevelCompanyId"
                    [parcelId]="parcelId"
                    [showComplianceInfo]="showComplianceInfo"
                >
                </asset-list-panel>
            </div>
        </div>
        <div
            class="row"
            [ngClass]="{ 'panel-maximized': panelMaximized && panelMaximized === 'responsibleEntityPanel' }"
        >
            <div
                class="col-xl-12 panel-container"
                [ngClass]="{ 'current-max-panel': panelMaximized === 'responsibleEntityPanel' }"
            >
                <responsible-entity-panel
                    class="full-panel"
                    [companyId]="topLevelCompanyId"
                    [parcelId]="parcelId"
                    [enableAllocations]="enableAllocations"
                >
                </responsible-entity-panel>
            </div>
        </div>
        @if (showComplianceInfo) {
            <div class="row">
                <div class="col-xl-12 panel-container">
                    <compliance-info-panel
                        [parcelId]="parcelId"
                        [siteId]="+siteId"
                        [allowEdit]="parcel.canEditCompanySetups"
                    >
                    </compliance-info-panel>
                </div>
            </div>
        }
        @if (entity) {
            <div class="row">
                <div class="col-xl-12 panel-container">
                    <contacts-panel [entity]="entity"></contacts-panel>
                </div>
            </div>
        }
    </div>
}
